class LostPageTransform {
  constructor() {
    "ngInject";
  }
}

export default LostPageTransform;



// WEBPACK FOOTER //
// ./src/pages/lost/lost.transforms.js